import { render, staticRenderFns } from "./supplementPop.vue?vue&type=template&id=4ac9bc4e&scoped=true"
import script from "./supplementPop.vue?vue&type=script&lang=js"
export * from "./supplementPop.vue?vue&type=script&lang=js"
import style0 from "./supplementPop.vue?vue&type=style&index=0&id=4ac9bc4e&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_21c2e229d51f918cc63b499183bc63cd/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ac9bc4e",
  null
  
)

export default component.exports